import { render, staticRenderFns } from "./BaseBottomSheet.vue?vue&type=template&id=f1a4a4f4&scoped=true"
import script from "./BaseBottomSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseBottomSheet.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseBottomSheet.vue?vue&type=style&index=0&id=f1a4a4f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a4a4f4",
  null
  
)

export default component.exports